import { Modal, Box, Typography, Avatar, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { GoogleMap, Marker, useLoadScript } from "@react-google-maps/api";

const center = {
  lat: 28.622794,
  lng: 77.3663089,
};

const containerStyle = {
  width: '100%',
  height: '400px',
  borderRadius: '20px 20px 0 0'
};

export default function QuickLookModal({ open, onClose }) {
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAP_KEY,
  });

  if (!isLoaded) return <div>Loading map...</div>;

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 600,
        bgcolor: 'background.paper',
        borderRadius: "20px",
        overflow: "hidden",
        boxShadow: 24,
      }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', p: 2 }}>
          <Typography sx={{ fontWeight: 600, fontSize: '20px' }}>Quick Look</Typography>
          <IconButton onClick={onClose}>
            <CloseIcon sx={{ color: '#FF4C4C' }} />
          </IconButton>
        </Box>

        <Box sx={{ position: 'relative' }}>
          <GoogleMap
            mapContainerStyle={containerStyle}
            center={center}
            zoom={15}
          >
            <Marker
              position={center}
              icon={{
                url: "https://i.imgur.com/your-avatar.png", // replace with avatar or custom marker
                scaledSize: new window.google.maps.Size(40, 40),
              }}
            />
          </GoogleMap>

          {/* Profile Info Box */}
          <Box sx={{
            position: "absolute",
            top: "20px",
            right: "20px",
            width: 200,
            bgcolor: "#fff",
            p: 2,
            borderRadius: "15px",
            boxShadow: "0px 4px 12px rgba(0,0,0,0.1)"
          }}>
            <Box sx={{ display: "flex", justifyContent: "center", mb: 1 }}>
              <Avatar
                alt="Profile"
                src="https://i.imgur.com/your-avatar.png"
                sx={{ width: 60, height: 60 }}
              />
            </Box>
            <Typography variant="body2" sx={{ fontWeight: 600 }}>
              Address
            </Typography>
            <Typography variant="body2" sx={{ mb: 1 }}>
              Sec 71, Noida, India, 201006
            </Typography>
            <Typography variant="body2" sx={{ fontWeight: 600 }}>
              Latitude
            </Typography>
            <Typography variant="body2" sx={{ mb: 1 }}>
              28.622794
            </Typography>
            <Typography variant="body2" sx={{ fontWeight: 600 }}>
              Longitude
            </Typography>
            <Typography variant="body2">
              77.3663089
            </Typography>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
}
